import { images } from "../../Constants/imageslinks";

const comments = [
  {
    author: " - Gavin",
    comment: "‘Am loving it!’",
  },
  {
    author: " - Ryan",
    comment: "‘I love love love the aesthetic’ ",
  },
  {
    author: " - Mary",
    comment: "‘The aesthetic is just *chefs kiss*’",
  },
  {
    author: "- Geoff",
    comment: "‘Such a great idea and design!’",
  },
  {
    author: " - Dennis",
    comment: "'..more time with my wife and kids'",
  },
  {
    author: " - Mary",
    comment: "‘Such a game changer for us iOS folks!’",
  },
  {
    author: " - Rebecca",
    comment: "'I really love it, it looks fantastic'",
  },
  {
    author: " - Jamie",
    comment: "'I just wanted to say how terrific it is...extremely clever..'",
  },
];

const comment = comments.map((item, index) => (
  <div className="flex md:gap-3 gap-2" key={index}>
    <div className="flex-shrink-0 md:w-[6px] w-1 md:h-[6px] h-1 bg-secondary100 rounded-full  mt-[10px]" />
    <div className="flex items-start  gap-1 text-secondary100">
      <p className="font-medium italic md:text-base text-xs md:leding-[30px] leading-6">
        {item.comment}
      </p>
      <p className="font-light md:text-base text-xs md:leading-[30px] leading-6 whitespace-nowrap">
        {item.author}
      </p>
    </div>
  </div>
));

const cardDetails = [
  {
    icon: images.dollar_icon,
    title: "Lock in a massive lifetime discount",
    description:
      "Today's your lucky day - we charge $49.99 yearly on the app store!",
  },
  {
    icon: images.hands_icon,
    title: "Full refund guarantee",
    description:
      "Not a fan? No problem. Email us for a full refund within 7 days.",
  },
  {
    icon: images.payment_icon,
    title: "Payment secured by Stripe",
    description:
      "The same payment processor Apple, Amazon, Etsy, Walmart & Target use. No credit card details seen or stored by us!",
  },
];

const cards = cardDetails.map((card, index) => (
  <div
    className="bg-primary100 rounded-lg p-6 flex gap-3 items-start"
    key={index}
  >
    <img src={card.icon} alt="refund icon" />
    <div className="flex flex-col gap-3">
      <p className="font-light text-2xl leading-[100%] text-secondary100">
        {card.title}
      </p>
      <p className="font-light text-base leading-[21px] text-secondary100 max-w-[437px]">
        {card.description}
      </p>
    </div>
  </div>
));

function MenuComponent() {
  return (
    <div className="bg-primary200 lg:min-h-screen col-span-5">
      <div className="pt-8 flex">
        <div className="lg:pt-[40px] pb-5 lg:px-5 md:px-8 px-4 flex flex-col gap-16 absolute">
          <div className="flex flex-col md:gap-6 gap-5">
            <p className="font-light md:text-lg text-xs md:leading-[27px] leading-5 max-w-[220px] lg:max-w-[21vw] 3xl:max-w-[430px] text-secondary100">
              Join 20,000+ others who have reclaimed control over their phones:
            </p>
            <div>{comment}</div>
          </div>
        </div>
        <div className="flex justify-end w-full lg:min-h-[420px] md:min-h-[390px] min-h-[290px]">
          <img
            src={images.hero_image}
            alt="mobile image"
            className="w-full max-w-[40vw] min-w-[30vw] md:min-w-[18vw] lg:min-w-[14vw] lg:max-w-[19vw] 3xl:max-w-[374px] 3xl:min-w-[374px] lg:max-h-[23vw] max-h-[45vw] md:max-h-[40vw] 3xl:max-h-[488px] "
          />
        </div>
      </div>
      <div className="px-5 pb-5 lg:flex flex-col gap-4 hidden">{cards}</div>
    </div>
  );
}

export default MenuComponent;
